export default "__VITE_ASSET__BBiMnyOO__"